import { Predicate } from 'effect';
import type { CaseAbility } from '@/abilities/createCaseAbility';
import type { DestinationAction, DestinationTree } from '@/abilities/destination';

/** A destination of the company dashboard: the page itself and its tabs. */
export type CompanyDashboardDestinationKey = 'root' | 'vendorExpenses';

/**
 * Each container's children, in landing order — the order its address looks for an open child. The order shown on
 * screen is the page's own list; reordering that one never moves where a user lands.
 */
export const companyDashboardDestinationTree: DestinationTree<CompanyDashboardDestinationKey> = {
  root: ['vendorExpenses'],
};

export const COMPANY_DASHBOARD_DESTINATION = 'CompanyDashboardDestination';

export type CompanyDashboardDestination = {
  readonly kind: typeof COMPANY_DASHBOARD_DESTINATION;
  readonly destination: CompanyDashboardDestinationKey;
};

export type CompanyDashboardAction = DestinationAction;

export type CompanyDashboardAbility = CaseAbility<CompanyDashboardAction, CompanyDashboardDestination>;

export const toCompanyDashboardDestination = (
  destination: CompanyDashboardDestinationKey,
): CompanyDashboardDestination => ({
  kind: COMPANY_DASHBOARD_DESTINATION,
  destination,
});

export const isCompanyDashboardDestination = (value: unknown): value is CompanyDashboardDestination =>
  Predicate.hasProperty(value, 'kind') && value.kind === COMPANY_DASHBOARD_DESTINATION;
